import type { SvgIconComponent } from '@mui/icons-material';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';

export const CATEGORY_ICON: Record<string, SvgIconComponent> = {
  Product: CategoryOutlinedIcon,
  Structure: LayersOutlinedIcon,
  Story: MenuBookOutlinedIcon,
  Graphics: ImageOutlinedIcon,
  Conceptual: LightbulbOutlinedIcon,
};
export const DEFAULT_CATEGORY_ICON = LabelOutlinedIcon;
